/* Activate route — v3 default (prod 2026-08-27). Legacy escape: ?activate_legacy=1 */

import { html } from "./ui.js";
import ActivateLegacy from "./activate-legacy-v2.js";
import ActivateDeskV3 from "./activate-desk-v3.js";

export {
  STEPS,
  KEYS,
  CLAIMABLE,
  activateMaxStepOf,
  activateMaxPhaseOf,
  activateSeatOf,
  activateMachineIdOf,
  claimableIdentifyOf,
  identifyStatusTone,
  safeActivatePath,
  softActivateErrorOf,
  fmtMac,
  hwIdFromMac,
  hintsOf,
  normalizeQrPayload,
} from "./activate-shared.js";

/** Activate v3 is default. Legacy 7-step wizard: ?activate_legacy=1 or sessionStorage croc.activate.legacy=1 */
export function activatePreviewV3() {
  try {
    const q = String(location.search || "");
    if (/(?:\?|&)activate_legacy=1(?:&|$)/.test(q)) return false;
    if (typeof sessionStorage !== "undefined" && sessionStorage.getItem("croc.activate.legacy") === "1") {
      return false;
    }
    return true;
  } catch {
    return true;
  }
}

export default function Activate(props) {
  if (activatePreviewV3()) {
    return html`<${ActivateDeskV3} ...${props}/>`;
  }
  return html`<${ActivateLegacy} ...${props}/>`;
}
